<template>
  <div class="login">
    <div class="bgPic">
      <img class="chat umeng-uc-0-cs-click" src="@/assets/images/login/bottom_live800.png" @click="openLive800">
      <img class="logo" :src="require('@/assets/images/login/'+logo+'.png')">
      <div class="form-box">
        <form>
          <div class="item">
            <span>账户</span>
            <div class="input-box" :class="login.customerNumber!=''?'border':''">
              <input v-model="login.customerNumber" placeholder="请输入账号/手机号" type="number" oninput="if(value.length>11)value=value.slice(0,11);value=value.replace(/[^\d]/g,'')" @mouseenter="onMouseOver" @mouseleave="onMouseOut">
              <img v-if="isPicClose" class="icon" :class="login.customerNumber!=''?'':'hide'" src="@/assets/images/login/close.png" alt="" @mouseenter="onMouseOver" @click="resetAccount()">
            </div>
          </div>
          <div class="item">
            <span>密码</span>
            <div class="input-box" :class="login.password!=''?'border':''">
              <input v-model="login.password" :type="[showPwd?'text':'password']" minlength="5" maxlength="16" placeholder="请输入交易密码">
              <img v-if="showPwd" class="icon" src="@/assets/images/login/open-code.png" alt="" @click="togglePwd()">
              <img v-else class="icon" src="@/assets/images/login/close-code.png" alt="" @click="togglePwd()">
            </div>
          </div>
          <div class="login-box umeng-uc-0-login-click" @click="toLogin()"><span class="login-btn" type="primary">登录</span></div>
          <div class="opt-box">
            <a class="umeng-uc-0-rcfd-click" :href="acUrl+'/cn/mobile/rcfd_account'" target="_blank">还没有账户？</a>
            <span class="umeng-uc-0-pwdrst-click" @click="goPassword">忘记密码</span>
          </div>
          <div class="errPrompt">{{ promptMsg }}</div>
        </form>
      </div>
      <div class="copyRight">
        <p>如有任何疑问，欢迎随时联系在线客服</p>
        <p>或致电24小时客服热线400-8428955（中国免费热线）</p>
        <p>Copyright © 2020 创富国际有限公司 版权所有 不得转载</p>
      </div>
    </div>
    <!--模拟账号登录弹窗-->
    <div v-if="isDome" class="popFixed">
      <div class="masking" @click="closeDomePop" />
      <div class="tcCon">
        <div class="item">
          <p>真实账号才能登录用户中心，查看账户信息</p>
        </div>
        <div class="btnCon only">
          <span @click="goAddMaterial">切换为真实账号</span>
        </div>
      </div>
    </div>
    <!--报错-->
    <div v-if="isErr" class="popFixed">
      <div class="masking" @click="closeErrPop" />
      <div class="tcCon">
        <div class="item">
          <p>{{ isErrMessage }}</p>
        </div>
        <div class="btnCon only">
          <span @click="closeErrPop">我知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
require('@/assets/css/login.css')
import api from '@/plugins/api'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      login: {
        /* customerNumber: 17388711484,17388711463,81018030
                    password: admin123,a123456*/
        customerNumber: '',
        password: ''
      },
      showPwd: false,
      promptMsg: '',
      showClose: false,
      acUrl: process.env.VUE_APP_AC,
      logo: process.env.VUE_APP_LOGO,
      isDome: false,
      domeUrl: '',
      isErr: false,
      isErrMessage: '',
      isPicClose: false
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    openLive800() {
      var url = `https://onlinecs.cffx139.net/Web/im.aspx?_=t&accountid=137707&visitorid=${new Date().getTime()}`
      var left = (screen.width / 2) - (600 / 2)
      var top = (screen.height / 2) - (400 / 2)
      window.open(url,
        'DescriptiveWindowName',
        'resizable,scrollbars=yes,status=1,width=800, height=550, top=' + top + ', left=' + left)
    },
    toLogin() {
      // 提交前验证
      this.promptMsg = ''
      if (this.login.customerNumber == '') {
        this.promptMsg = '您的用户账号为空'
        return
      }
      if (this.login.password == '') {
        this.promptMsg = '您的密码为空'
        return
      }
      if (this.login.password.match(/\s/g)) {
        this.promptMsg = '密码不能有空白键'
        return
      }
      const loginParam = {
        password: this.login.password
      }
      if (this.login.customerNumber.trim().length <= 8) {
        loginParam.customerNumber = this.login.customerNumber
      } else {
        loginParam.mobilePhonePrefix = '86'
        loginParam.mobilePhone = this.login.customerNumber
      }
      // 提交
      const readyData = this.$qs.stringify(loginParam)
      this.$bus.$emit('loading', false, '登录中')
      api.login(readyData).then(res => {
        if (res.status) {
          if (res.data.code == 200) {
            const user = {
              loginname: res.data.data.one_sequence.customerNumber,
              pwd: res.data.data.one_sequence.encryption,
              companyId: res.data.data.one_sequence.companyId,
              mobilePhone: res.data.data.one_sequence.mobilePhone
            }
            this.$store.dispatch('setUser', user)
            this.$store.dispatch('setToken', res.data.data.token)
            this.$store.dispatch('setGts2CustomerId', res.data.data.one_sequence.gts2CustomerId)
            this.$store.dispatch('setPageType', 'center')
            this.$router.go(0)
          } else if (res.data.code == 501) {
            this.$bus.$emit('loading', true)
            this.isDome = true
            this.domeUrl = res.data.data
          } else {
            this.$bus.$emit('loading', true)
            if (res.data.code_desc == '帳戶被鎖定') {
              this.isErr = true
              this.isErrMessage = '您的账户被锁定，请联系客服或重置密码'
            } else {
              this.isErr = true
              this.isErrMessage = res.data.code_desc
            }
          }
        } else {
          this.$bus.$emit('loading', true)
          this.isErr = true
          this.isErrMessage = '网络错误'
        }
      })
    },
    resetAccount() {
      this.login.customerNumber = ''
    },
    togglePwd() {
      this.showPwd = !this.showPwd
    },
    goPassword() {
      this.$bus.$emit('loading', false)
      this.$router.push({ path: '/forgetPwd' })
    },
    closeDomePop() {
      this.isDome = !this.isDome
    },
    closeErrPop() {
      this.isErr = !this.isErr
    },
    goAddMaterial() {
      this.$bus.$emit('loading', false)
      window.location.href = this.domeUrl
    },
    onMouseOver() {
      this.isPicClose = true
    },
    onMouseOut() {
      this.isPicClose = false
    }
  }
}
</script>

